import type { StyleRules, MakeStylesHook } from '@egr/xbox/utils/tss-react';

import theme from '../styles/theme';

import { DefaultDialogs } from './DefaultDialogs';
import { YoutubeDialog } from './YoutubeDialog';
import DeviceInfo from './debug/DeviceInfo';

import { AppThemeProvider } from '@egr/xbox/egr-gui-elements/AppThemeProvider/AppThemeProvider';
import { ErrorBoundary } from '@egr/xbox/egr-gui-elements/single-components/ErrorBoundary';
import { getEnvBoolean } from '@egr/xbox/utils/ReactScriptHelper';
import { makeStyles } from '@egr/xbox/utils/tss-react';

function styles(): StyleRules<'rootWrapper'> {
    return {
        rootWrapper: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            overflow: 'hidden',
            minHeight: '100dvh',
        },
    };
}

const useStyles: MakeStylesHook<'rootWrapper'> = makeStyles({ name: 'App' })(styles);

const DEBUG_MODE = getEnvBoolean('DEBUG', false);

export const AppWrapper: React.FC<React.PropsWithChildren> = (props) => {
    const { classes } = useStyles();

    return (
        <div className={classes.rootWrapper}>
            <ErrorBoundary
                silent={false}
                color="default"
            >
                <AppThemeProvider
                    darkTheme={theme}
                    lightTheme={theme}
                >
                    {props.children}
                    <YoutubeDialog />
                    <DefaultDialogs />
                    {DEBUG_MODE && <DeviceInfo />}
                </AppThemeProvider>
            </ErrorBoundary>
        </div>
    );
};
